<template>
  <v-card class="mb-12" elevation="0">
    <v-form ref="form"
            v-model="valid"
            lazy-validation
    >
      <v-row>
        <v-col md="6" cols="12">
          <label>عنوان دوره</label>
          <v-text-field v-model="dataModel.title" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label>وضعیت دوره</label>
          <v-select clearable :items="statusItems" class="rounded-lg mt-2 sm-font400-14" item-text="title"
                    item-value="id"
                    hide-details solo v-model="dataModel.is_active"></v-select>
        </v-col>
        <v-col cols="12">
          <label>توضیحات</label>
          <v-textarea v-model="dataModel.description" class="rounded-lg mt-2 sm-font400-14" rows="7" hide-details
                      solo></v-textarea>
        </v-col>
        <v-col cols="12">
          <label>جزییات</label>
          <v-textarea v-model="dataModel.short_description" class="rounded-lg mt-2 sm-font400-14" rows="7"
                      solo counter="255" :rules="[rules.length(255)]"></v-textarea>
        </v-col>
        <v-col md="6" cols="12">
          <label>تصویر بنر دوره</label>
          <v-file-input prepend-icon="" append-icon="mdi-upload" v-model="dataModel.image"
                        class="rounded-lg mt-2 sm-font400-14" solo hide-details @change="changedImage">
            <template slot="prepend-inner" v-if="imagePreview && showImagePreview">
              <img width="40" :src="imagePreview"/>
            </template>
          </v-file-input>
        </v-col>
        <v-col md="6" cols="12">
          <label>ویدیو دوره</label>
          <v-file-input v-model="dataModel.video" prepend-icon="" append-icon="mdi-upload"
                        class="rounded-lg mt-2 sm-font400-14" solo hide-details @change="changedVideo">
            <template slot="prepend-inner" v-if="videoPreview">
              <a target="_blank" :href="videoPreview">video</a>
            </template>
          </v-file-input>
        </v-col>
        <!--        <v-col md="6" cols="12">-->
        <!--          <label>تعداد برنامه ها</label>-->
        <!--          <v-text-field v-model="dataModel.lesson_count" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line-->
        <!--                        hide-details></v-text-field>-->
        <!--        </v-col>-->
        <!--        <v-col md="6" cols="122">-->
        <!--          <label>تعداد حرکت</label>-->
        <!--          <v-text-field v-model="dataModel.session_count" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line-->
        <!--                        hide-details></v-text-field>-->
        <!--        </v-col>-->
        <v-col md="6" cols="12">
          <label>تعداد جلسات</label>
          <v-text-field v-model="dataModel.session_count" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label>قیمت دوره</label>
          <v-text-field type="number" v-model="dataModel.price" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
          <span>{{ Number(dataModel.price)?.toLocaleString() }} تومان</span>
        </v-col>
        <v-col md="6" cols="12">
          <label>ظرفیت دوره</label>
          <v-text-field v-model="dataModel.capacity" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label>مربی دوره</label>
          <v-select clearable item-text="username" item-value="id" :items="teachers"
                    v-model="dataModel.teachers" multiple solo class="rounded-lg mt-2"
                    label="مربی دوره"></v-select>
        </v-col>
        <v-col md="6" cols="12">
          <label>لینک جلسات</label>
          <v-text-field v-model="dataModel.session_link" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>

        <v-col md="6" cols="12">
          <label>لینک گروه تلگرامی</label>
          <v-text-field v-model="dataModel.group_link" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>

        <v-col v-if="$route.query.course_type !== 'Online_Offline'" cols="12">
          <label>فایل معرفی دوره</label>
          <v-file-input v-model="dataModel.description_file" prepend-icon="" append-icon="mdi-upload"
                        class="rounded-lg mt-2 sm-font400-14" solo hide-details @change="changedFile">
            <template slot="prepend-inner" v-if="filePreview && showFilePreview">
              <a target="_blank" :href="filePreview">file</a>
            </template>
          </v-file-input>
        </v-col>
        <v-col cols="12">
          <p class="sm-font600-16 thirdColor--text mb-0">تقویم دوره</p>
        </v-col>
        <v-col md="6" cols="12">
          <label>تاریخ شروع</label>
          <v-text-field :value="dataModel.start | moment(`jYYYY/jMM/jDD`)" solo
                        append-icon="mdi-calendar" class="rounded-lg custom-input"></v-text-field>
          <date-picker type="date" v-model="dataModel.start" format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD"
                       custom-input=".custom-input"/>
        </v-col>
        <v-col md="6" cols="12">
          <label>تاریخ پایان</label>
          <v-text-field :value="dataModel.end | moment(`jYYYY/jMM/jDD`)" solo
                        append-icon="mdi-calendar" class="rounded-lg custom-input2"></v-text-field>
          <date-picker type="date" v-model="dataModel.end" format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD"
                       custom-input=".custom-input2"/>
        </v-col>
        <v-col md="6" cols="12">
          <label>روزهای برگزاری</label>
          <v-text-field v-model="dataModel.event_day" class="rounded-lg pr-0 sm-font400-14" solo
                        single-line height="48" hide-details></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label>ساعت برگزاری</label>
          <v-text-field v-model="dataModel.event_time" class="rounded-lg pr-0 sm-font400-14" solo
                        single-line height="48" hide-details></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label>مهلت ثبت نام</label>
          <v-text-field :value="dataModel.registration_deadline | moment(`jYYYY/jMM/jDD`)" solo
                        append-icon="mdi-calendar" class="rounded-lg custom-input3"></v-text-field>
          <date-picker type="date" v-model="dataModel.registration_deadline" format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD"
                       custom-input=".custom-input3"/>
        </v-col>
        <v-col cols="12" class="d-flex justify-end">
          <v-btn color="positive" class="textColor--text sm-font500-16 rounded-xl me-3" depressed height="48"
                 width="230" @click="nextStep" :loading="loading"
                 :disabled="!valid">
            ثبت و ادامه
          </v-btn>

          <v-btn width="230" height="48" depressed color="nagative" class="textColor--text sm-font500-16 rounded-xl"
                 @click="cancelProcess">
            انصراف
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import courseApi from "@/Services/modules/courses";
import users from "@/Services/modules/users";

export default {
  name: "steps",
  props: {
    contentData: {
      type: Object,
    },
    formType: {
      type: String
    }
  },
  data() {
    // console.log(this.$route.query.course_type)
    return {
      valid: true,
      rules: {
        length: len => v => (v || '').length <= len || `تعداد کاراکتر بیش از حد مجاز`,
      },
      dataModel: this.contentData || {
        course_type: this.$route.query.course_type,
        price: ""
      },
      statusItems: [{id: true, title: "فعال"}, {id: 1, title: "غیرفعال"}],
      teachers: [],
      showImagePreview: true,
      imagePreview: null,
      showVideoPreview: true,
      videoPreview: null,
      showFilePreview: true,
      filePreview: null
    }
  },
  mounted() {
    this.getTeachers()

    this.imagePreview = this.dataModel.image
    this.videoPreview = this.dataModel.video
    this.filePreview = this.dataModel.description_file


    delete this.dataModel.description_file

    delete this.dataModel.video

    delete this.dataModel.image
  },
  methods: {
    getTeachers() {
      let data = {
        is_teacher: true,
        page: 1,
        size: 50
      }
      users.getAllUsers(data).then(res => {
        this.teachers = res.data.results
      })
    },
    nextStep() {
      // let formData = new FormData();
      // formData.append("title", this.dataModel.title);
      // formData.append("is_active", this.dataModel.is_active);
      // formData.append("description", this.dataModel.description);
      // formData.append("short_description", this.dataModel.short_description);
      // formData.append("lesson_count", this.dataModel.lesson_count);
      // formData.append("session_count", this.dataModel.session_count);
      //
      //
      //
      // formData.append("event_time", this.dataModel.event_time);
      // formData.append("event_day", this.dataModel.event_day);
      // formData.append("end", this.dataModel.end);
      // formData.append("start", this.dataModel.start);
      // formData.append("group_link", this.dataModel.group_link);
      // formData.append("teachers", JSON.stringify(this.dataModel.teachers));
      // formData.append("capacity", this.dataModel.capacity);
      // if (this.dataModel.image) {
      //   formData.append("image", this.dataModel.image)
      // }
      // if (this.dataModel.video) {
      //   formData.append("video", this.dataModel.video)
      // }
      // if (this.dataModel.description_file) {
      //   formData.append("description_file", this.dataModel.description_file)
      // }

      this.loading = true
      let configHeader = {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
      if (this.formType === 'create') {
        courseApi.createClass(this.dataModel, configHeader).then(res => {
          this.$router.push(`/courses/class/edit-independent/${res.data.id}?tab=2`)
        }).catch((err) => {
          console.log(err);
        }).finally(()=> {
           this.loading = false
        })
      } else {
        courseApi.updateClass(this.$route.params.id, this.dataModel, configHeader).then(() => {
          this.$emit('nextStep', 2)
        }).catch((err) => {
          console.log(err);
        }).finally(()=> {
           this.loading = false
        })
      }
      this.$emit('nextStep', 2)
    },
    cancelProcess() {
      this.$router.push('/courses/class-list')
    },
    changedImage() {
      this.showImagePreview = false
    },
    changedVideo() {
      this.showVideoPreview = false
    },
    changedFile() {
      this.showFilePreview = false
    },
  }
}
</script>

<style scoped></style>
